import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full h-[calc(100vh-52px)] flex" }
const _hoisted_2 = {
  key: 0,
  class: "w-[190px] mt-10 flex flex-col items-center gap-3"
}
const _hoisted_3 = {
  key: 1,
  class: "min-w-[190px] w-[190px]"
}
const _hoisted_4 = { class: "w-full" }

import InstallerProfile from "@/components/installer/InstallerProfile.vue";
import InlineLoader from "@/components/Loaders/InlineLoader.vue";
import SecondaryPageHeader from "@/components/PageHeader/SecondaryPageHeader.vue";
import InstallersSidemenu from "@/components/Sidebar/installer/InstallersSidemenu.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import { useUserStore } from "@/stores/user";
import { InstallerDetails, Worker } from "@/types";
import client from "@/utils/axios";
import { computed, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";

// Route

export default /*@__PURE__*/_defineComponent({
  __name: 'BonusReportDetails',
  setup(__props) {

const route = useRoute();

// Store
const userStore = useUserStore();

// Refs
const workers = ref<Worker[]>([]);
const selectedWorker = ref<string | null>(null);
const isLoading = ref<boolean>(false);
const reports = ref<InstallerDetails | null>(null);

// Functions
const getAllInstallers = async () => {
  isLoading.value = true;
  try {
    const response = await client.get("/installers");
    workers.value = response.data;
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

const getInstallerReport = async () => {
  try {
    const response = await client.get(
      `/installers/${route.params.id}/report/${route.params.reportId}?locale=${currentLanguage.value}`
    );
    reports.value = response.data;
  } catch (error) {
    console.log(error);
  }
};

const handleSelectWorker = (workerId: string) => {
  if (selectedWorker.value === workerId) {
    selectedWorker.value = null;
  } else {
    selectedWorker.value = workerId;
  }
};

// Computed properties
const selectedWorkerProfile = computed(() => {
  return workers.value.find((item: Worker) => item.id === route.params.id);
});

const currentLanguage = computed(() => userStore.language);
let lastDatabaseTranslationUpdateTimestamp = computed(
  () => userStore.translationsUpdateTimestamp
);

// Watchers
watch(selectedWorkerProfile, (newValue?: Worker) => {
  if (newValue) {
    handleSelectWorker(newValue.id);
  }
});

watch(
  () => route.params.reportId,
  (newReportId) => {
    if (newReportId) {
      getInstallerReport();
    }
  },
  { immediate: true }
);

watch(
  currentLanguage,
  async (newLang: string, oldLang?: string) => {
    if (newLang && oldLang && newLang !== oldLang) {
      await getInstallerReport();
    }
  },
  { immediate: true }
);

watch(
  lastDatabaseTranslationUpdateTimestamp,
  async (newTimestamp: number, oldTimestamp?: number) => {
    if (newTimestamp && oldTimestamp && newTimestamp !== oldTimestamp) {
      await getInstallerReport();
    }
  },
  { immediate: true }
);

// Lifecycle hooks
onMounted(() => {
  getAllInstallers();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MainLayout, null, {
    default: _withCtx(() => [
      _createVNode(SecondaryPageHeader, {
        "is-installer-profile": true,
        "is-installer-report": true,
        "selected-worker-profile": selectedWorkerProfile.value,
        "bonus-reports": reports.value?.bonusReports
      }, null, 8, ["selected-worker-profile", "bonus-reports"]),
      _createElementVNode("div", _hoisted_1, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(InlineLoader),
              _createVNode(InlineLoader),
              _createVNode(InlineLoader),
              _createVNode(InlineLoader)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (reports.value)
                ? (_openBlock(), _createBlock(InstallersSidemenu, {
                    key: 0,
                    workers: workers.value,
                    "installer-details": reports.value,
                    onSelectWorker: handleSelectWorker
                  }, null, 8, ["workers", "installer-details"]))
                : _createCommentVNode("", true)
            ])),
        _createElementVNode("div", _hoisted_4, [
          (!isLoading.value)
            ? (_openBlock(), _createBlock(InstallerProfile, {
                key: 0,
                "worker-name": reports.value?.worker?.fullname,
                "worker-role": reports.value?.worker?.role,
                "worker-image": reports.value?.worker?.worker_image,
                bonus: reports.value?.report?.bonus,
                "completed-termins": reports.value?.report?.completedTermins,
                "completed-termins-percentage": reports.value?.report?.completedPercentage,
                termins: reports.value?.report?.termins,
                "is-report": true
              }, null, 8, ["worker-name", "worker-role", "worker-image", "bonus", "completed-termins", "completed-termins-percentage", "termins"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})